import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { getAuthorizedRoutesForSidebarMenu, SelectedModuleContext } from '../../../../constants/acl-config';
import { useUserPolicy } from '../../../../user-policy';

const AuthorizedLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 64px 0 0;
  line-height: normal;

  :hover {
    font-weight: 500;
  }

  a {
    font-size: 14px;
    color: #262626;
    padding: 10px 24px;

    &.active {
      background: #f6f7f9;
      font-weight: 500;
    }
  }
`;

function AuthorizedLinks() {
  const { selectedModule } = useContext(SelectedModuleContext);
  const { userAccount } = useUserPolicy();

  if (!selectedModule || !userAccount) {
    return null;
  }

  const routes = getAuthorizedRoutesForSidebarMenu(userAccount.ability, selectedModule);
  return (
    <AuthorizedLinksWrapper>
      {routes.map(({ url, name }) => (
        <NavLink
          exact
          to={url}
        >
          {name}
        </NavLink>
      ))}
    </AuthorizedLinksWrapper>
  );
}

AuthorizedLinks.propTypes = {};

export default AuthorizedLinks;
